import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { EnterpriseSearchService } from '@sabstravtech/obtservices/angular';

import { ChatWidgetInputBase } from '../chat-widget-input-base';

export interface ChatJourneyDetailsAnswer {
  destination: string;
  mobileNum: string;
  outFlight: string;
  outTerminal: string;
  returnFlight: string;
  returnTerminal: string;
}

@Component({
  selector: 'app-chat-journey-details-input',
  standalone: false,
  templateUrl: './chat-journey-details-input.component.html',
  styleUrls: ['./chat-journey-details-input.component.scss']
})
export class ChatJourneyDetailsInputComponent extends ChatWidgetInputBase implements OnChanges {
  @Input() savedValue: Record<string, unknown> | null = null;
  @Input() required = false;
  @Output() answer = new EventEmitter<ChatJourneyDetailsAnswer>();
  @Output() skip = new EventEmitter<void>();

  destination = '';
  mobileNum = '';
  outFlight = '';
  outTerminal = '';
  returnFlight = '';
  returnTerminal = '';

  focus$ = new Subject<string>();
  chosenSummary: string | null = null;

  constructor(private searchService: EnterpriseSearchService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.onlyLockedChanged(changes)) {
      return;
    }
    // this.journeyCarrier = '';
    // this.journeyrierModel = null;
    // this.selectedCarrier = null;
    // const savedCarrier = this.savedValue?.['journeyCarrier'];
    // if (typeof savedCarrier === 'string' && savedCarrier.trim()) {
    //   const code = savedCarrier.trim().toUpperCase();
    //   this.journeyCarrier = code;
    //   this.selectedCarrier = { title: code, value: code };
    //   this.journeyrierModel = this.selectedCarrier;
    //   this.searchService
    //     .getAirlinesList(code)
    //     .pipe(catchError(() => of([])))
    //     .subscribe((airlines) => {
    //       const match = (airlines ?? []).find((airline) => airline.code === code);
    //       if (match && this.journeyCarrier === code) {
    //         this.selectedCarrier = { title: match.name, value: match.code };
    //         this.journeyrierModel = this.selectedCarrier;
    //         this.journeyCarrier = match.code;
    //       }
    //     });
    // }
    // this.journeyNumber =
    //   this.savedValue?.['journeyNumber'] != null ? String(this.savedValue['journeyNumber']) : '';
    this.chosenSummary = null;
  }

  get isValid(): boolean {
    return this.destination &&
      this.mobileNum &&
      this.outFlight &&
      this.outTerminal &&
      this.returnFlight &&
      this.returnTerminal
      ? true
      : false;
  }

  onContinue(): void {
    if (this.locked || !this.isValid) {
      return;
    }
    this.chosenSummary = `Your journey is to ${this.destination} departing flight  ${this.outFlight} at terminal ${this.outTerminal}
     returning flight ${this.returnFlight} at terminal ${this.returnTerminal} and your mobile number is: ${this.mobileNum}`;
    this.answer.emit({
      destination: this.destination,
      mobileNum: this.mobileNum,
      outFlight: this.outFlight,
      outTerminal: this.outTerminal,
      returnFlight: this.returnFlight,
      returnTerminal: this.returnTerminal
    });
  }

  onSkip(): void {
    if (this.locked || this.required) {
      return;
    }
    this.chosenSummary = 'Skipped';
    this.skip.emit();
  }
}
